<template>
  <div class="container">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <b-card>
      <div slot="header" class="d-flex">
        <img v-if="!mobilecheck()" alt="mDrive Sync Logo Wide" class="mdrive-sync-logo-wide" src="../../assets/mdrive_logo.png" width="500" />
        <h1 class="mDrive-tagline">Sign up for mDrive!</h1>
      </div>


      <div class="signup-thumbprint-bg"></div>
      <div id="searchPanel" class="card" v-show="!dealerSearched">
        <div class="card-header text-center">
          <div class="h6">Search for your make/dealership to get started</div>

          <input type="text" class="form-control m-2" v-model.trim="searchString" @keyup.enter="searchForDealership()" /><br />
          <a class="btn btn-primary m-auto" @click="searchForDealership()" href="#">Search For Matching Dealerships</a>

        </div>
        <div class="card-content">

          <DxList :data-source="dataSource"
                  :height="400"
                  :onItemClick="selectedDealership"
                  class="m-auto" />

        </div>
        <a href="#" class="m-2" @click="notListed()" v-show="!dealerSearched">My dealership is not listed...</a>
      </div>
      <div class="card" v-show="dealerSearched">
        <a href="#" @click="dealerSearched = false" v-show="dealerSearched" class="m-auto">Back to Search</a>
        <dealerInformation ref="dealerInformation"></dealerInformation>
      </div>

      <div slot="footer" class="d-flex">
        <a class="btn btn-primary ml-auto sign-me-up-btn" @click="signup()" href="#">Sign Me Up!</a>
      </div>
    </b-card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import dealerInformation from '@/views/DealerInformation'
  import VeeValidate from 'vee-validate'
  import DxList from 'devextreme-vue/list';
  import ArrayStore from 'devextreme/data/array_store';

  import { load, getInstance } from 'recaptcha-v3'
  const reCaptchAdminKey = '6LfOO_8UAAAAAAyYk9WTqSlOoBVFja-VbFINdzLj'


  export default {
    components: {
      DxList,
      dealerInformation
    },
    provide() {
      return {
        $validator: this.$validator,
      }
    },
    data() {
      return {
        errMsg: '',
        dismissibleType: 'danger',
        showDismissibleAlert: false,
        dataSource: new ArrayStore({
          key: 'Name',
          data: null
        }),
        selectedDealer: {},
        dealerSearched: false,
        searchString: '',
        selectedItemKeys: [],
      }
    },
    created() {
      const self = this
      setTimeout(async function () {

        self.recaptcha = await load(reCaptchAdminKey)

      }, 100)

    },

    methods: {
      searchForDealership() {
        var obj = {
          SEARCH_STRING: this.searchString
        }

        axios.post('/api/mDrive/SearchDealerships', obj)
          .then(response => {
            console.log(response)
            this.dataSource = new ArrayStore({
              key: 'Id',
              data: response.data
            })

          })
          .catch(error => {


            self.boolLoading = false

            self.errMsg = 'There was an error with your request : '
            if (error !== undefined && error.message !== undefined && error.response.data !== undefined) {
              self.errMsg = self.errMsg + error.response.data

            } else {
              self.errMsg = self.errMsg + error
            }

            self.showDismissibleAlert = true
          })
      },
      notListed() {
        this.dealerSearched = true
        this.$refs.dealerInformation.lead.dealer_name = ''
        this.$refs.dealerInformation.lead.address1 = ''
        this.$refs.dealerInformation.lead.city = ''
        this.$refs.dealerInformation.lead.state = ''
        this.$refs.dealerInformation.lead.zip = ''
        this.$refs.dealerInformation.lead.dealer_url = ''
        this.$refs.dealerInformation.lead.phone = ''

      },
      selectedDealership(e) {
        var obj = {
          SELECTED_DEALER_ID: e.itemData.id
        }
        axios.post('/api/mDrive/GetDealerData', obj)
          .then(response => {
            self.boolLoading = true
            this.dealerSearched = true
            this.$refs.dealerInformation.lead = response.data
          })
          .catch(error => {
            self.boolLoading = false
            self.errMsg = 'There was an error with your request : '
            if (error !== undefined && error.message !== undefined && error.response.data !== undefined) {
              self.errMsg = self.errMsg + error.response.data
            } else {
              self.errMsg = self.errMsg + error
            }

            self.showDismissibleAlert = true
          })
      },
      submitSignup(token) {
        var self = this
        this.$validator.validateAll().then((result) => {
          if (result) {
            var obj = {
              DEALER_NAME: this.$refs.dealerInformation.lead.dealer_name,
              ADDRESS1: this.$refs.dealerInformation.lead.address1,
              ADDRESS2: this.$refs.dealerInformation.lead.address2,
              CITY: this.$refs.dealerInformation.lead.city,
              STATE: this.$refs.dealerInformation.lead.state,
              ZIP: this.$refs.dealerInformation.lead.zip,
              PHONE: this.$refs.dealerInformation.lead.phone,
              CONTACT_FIRSTNAME: this.$refs.dealerInformation.lead.contact_firstname,
              CONTACT_LASTNAME: this.$refs.dealerInformation.lead.contact_lastname,
              CONTACT_POSITION: this.$refs.dealerInformation.lead.contact_position,
              CONTACT_PHONE: this.$refs.dealerInformation.lead.contact_phone,
              DEALER_URL: this.$refs.dealerInformation.lead.dealer_url,
              CONTACT_EMAIL: this.$refs.dealerInformation.lead.contact_email,
              SELECTED_MAKES: this.$refs.dealerInformation.lead.selected_makes,
              TOKEN: token
            }

            axios.post('/api/mDrive/Signup', obj)
              .then(response => {
                self.errMsg = 'Your mDrive request was submitted'
                self.dismissibleType = 'success'
                self.showDismissibleAlert = true
                self.boolLoading = false
                self.$emit('clicked', true)
                //if (self.user.USER_ID === undefined) {
                //  self.user['USER_ID'] = parseInt(response.data)
                //}

                self.$router.push('/mDriveConfirmation')

              })
              .catch(error => {


                self.boolLoading = false

                self.errMsg = 'There was an error with your request : '
                if (error !== undefined && error.message !== undefined && error.response.data !== undefined) {
                  self.errMsg = self.errMsg + error.response.data

                } else {
                  self.errMsg = self.errMsg + error
                }

                self.showDismissibleAlert = true
              })
          } else {
            // alert('Please correct errors first');
            self.boolLoading = false
            self.errMsg = 'Please correct errors first'
            self.dismissibleType = 'danger'
            self.showDismissibleAlert = true

            setTimeout(function () {
              self.showDismissibleAlert = false
              self.errMsg = ''
            }, 8000)
          }
        })

      },
      mobilecheck() {
        if (screen.width <= 1041) {
          return true;
        }
        else {
          return false;
        }
      },

      signup() {
        var self = this

        this.$refs.dealerInformation.$validator.validateAll().then(async (result) => {



          if (!result) {
            // alert('Please correct errors first');

            self.errMsg = 'Please correct errors first'
            self.dismissibleType = 'danger'
            self.showDismissibleAlert = true

            setTimeout(function () {
              self.showDismissibleAlert = false
              self.errMsg = ''
            }, 8000)
          }
          self.token = await self.recaptcha.execute('mDriveSignup')

          this.submitSignup(self.token)


          getInstance().hideBadge()

        })
      }
    }
  }
</script>

<style scoped>
  .form-control {
    border-radius: .25rem !important;
  }

  .card {
    background: transparent;
  }

  .signup-thumbprint-bg {
    width: 100%;
    height: calc(100% - 237px);
    background-image: url(https://www.marketscan.com/Portals/0/blue-thumbprint-5.png);
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    margin: 0;
    top: 161px;
    left: 0;
    z-index: -1;
  }

  .mdrive-sync-logo-wide {
    margin-left: -66px;
  }

  .mDrive-tagline {
    height: auto;
    position: absolute;
    top: 88px;
    left: 394px;
    color: #231f20;
    font-family: 'Calibri';
  }

  .sign-me-up-btn {
    border-radius: .25rem;
  }

  .card-footer {
    padding: 1.25rem calc(1.25rem + 15px);
  }

  @media (max-width: 768px) {
    body > div.container > div > div.card-header {
      padding: 0.75rem 1.25rem 6.75rem;
    }

    .mdrive-sync-logo-wide {
      margin-left: auto;
    }

    .mDrive-tagline {
      width: 508px;
      height: auto;
      position: absolute;
      top: 138px;
      text-align: center;
      left: 0;
      color: #231f20;
      font-family: 'Calibri';
    }
  }

  @media (max-width: 575px) {
    body > div.container > div > div.card-header {
      padding: 0.75rem 1.25rem 4.75rem;
    }

    .mDrive-tagline {
      width: 100%;
      top: 23vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mDrive/mDriveSignup.vue